import { Reveal, Kicker } from "./Reveal";

const INDICATORS = [
  ["£50M–£1B", "Revenue", "Commercial scale large enough for pricing decisions to matter materially."],
  ["10,000+", "Active price points", "Enough decision volume for automation and governance to become valuable."],
  ["Named", "Pricing owner", "A clear business owner for pricing decisions and policy."],
  ["Margin pressure", "Or stalled dynamic pricing", "An identifiable commercial problem with measurable economics."],
];

export default function Customers() {
  return (
    <section id="customers" className="border-b border-white/10" data-testid="customers-section">
      <div className="mx-auto max-w-[1600px] px-6 py-28 lg:px-12 lg:py-40">
        <Reveal>
          <Kicker index="03" label="First customers" />
          <h2 className="max-w-5xl font-display text-4xl font-extrabold leading-[1.02] tracking-tighter sm:text-5xl lg:text-6xl" data-testid="customers-heading">
            Built first for high-volume <span className="text-[#00FF41]">retail and e-commerce</span> pricing.
          </h2>
          <p className="mt-8 max-w-2xl font-mono text-sm leading-relaxed text-zinc-400">
            The initial design-partner profile is a business where pricing volume has already outgrown
            human review capacity.
          </p>
        </Reveal>

        <div className="mt-20 grid border border-white/10 sm:grid-cols-2 lg:grid-cols-4">
          {INDICATORS.map(([value, label, desc], i) => (
            <Reveal key={label} delay={i * 0.08} className="border-b border-white/10 p-10 transition-colors duration-500 last:border-b-0 hover:bg-[#0F0F11] sm:border-r sm:last:border-r-0 lg:border-b-0">
              <div className="font-display text-3xl font-extrabold tracking-tighter text-white" data-testid={`customer-indicator-${i + 1}`}>{value}</div>
              <div className="mt-2 font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41]">{label}</div>
              <p className="mt-5 font-mono text-xs leading-relaxed text-zinc-500">{desc}</p>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-10 max-w-3xl font-mono text-sm leading-relaxed text-zinc-400" data-testid="customers-closing">
            B2C retail and e-commerce provide the fastest proof cycle.{" "}
            <span className="text-white">B2B distribution follows as a higher-value, governance-intensive second wave.</span>
          </p>
        </Reveal>
      </div>
    </section>
  );
}
